<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="[getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <v-divider class="py-2" />
    <div
      v-for="(model, index) in dynamicModel"
      :key="model[mappedKeys[idRef]['contextTypeId']]"
    >
      <vue-form-generator
        tag="div"
        :schema="{ fields: [dynamicSchema[index]] }"
        :model="model"
        :options="{ mode: formOptions.mode, page: formOptions.page, tab: formOptions.tab, step: formOptions.step }"
        v-if="(model && Object.keys(model).length) || config.DEV_MODULE"
      />
    </div>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';                
import defaultSchema from './schemaDynamicFields';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  data() {
    return {
      dynamicSchema: [],
      idRef: "usingContextTable",
      mappedKeys: {
        usingContextTable: {
          contextTypeId: "contextTypeId"
        },
        usingId: {
          contextTypeId: "id"
        },
        type: "type",
        value: "value",
        values: "values",
        label: "label",
        placeholder: "placeholder",
        description: "description"
      },
      customSchema: {}
    }
  },

  created() {
    this.customizeKeys();
    this.generateDynamicSchema();
  },

  computed: {
    dynamicModel() {
      return this.model[this.schema.model]
    }
  },

  watch: {
    model() {
      this.$nextTick(() => {
        this.customizeKeys();
        this.generateDynamicSchema();
      });
    }
  },

  methods: {
    async onBlur() {
      this.changeEvents();
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    },

    updateModel(newModel) {
      this.$store.commit('page/updateModel', { page: this.formOptions.page, mode: this.formOptions.mode, model: newModel });
    },

    customizeKeys() {
      let keys;

      if ('mappedKeys' in this.schema) {
        keys = this.schema.mappedKeys;

        this.idRef = (
          'usingId' in keys ? 'usingId' : 
          'usingContextTable' in keys && 'usingContextTable'
        );

        _.merge(this.mappedKeys, this.schema.mappedKeys);
        return;
      }
      // Usa as configurações/chaves default
      keys = this.mappedKeys;
    },

    componentShouldShowLabel(id) {
      // Atualmente apenas o input de colorPicker precisa de um label Fixo fora do campo
      const idComponentAllowed = [9];

      return idComponentAllowed.includes(id);
    },

    mountedSchemaComponentsWithLookup(field) {
      const type = field[this.mappedKeys.type];
      if (type !== 11 && type !== 12) return {}

      switch(type) {
        case 11:
          return this.mountedSchemaForTypeLookupFixed(field);
        case 12:
          return this.mountedSchemaForTypeLookupWindow(field);
        default:
          return {};
      }
    },
    mountedSchemaForTypeLookupFixed(field) {
      let schemaValueLookup = {
        "value": "",
        "text": "",
        "isValid": true,
        "notifications": [],
        "selected": false
      };

      let values = field[this.mappedKeys.values] ?? [];
      let items = Array.isArray(values)
        ? values.map(item => ({
            ...schemaValueLookup,
            value: item['código'],
            text: item['descrição'],
            selected: item?.selected ?? false
          }))
        : [];

      let newProps = {
        "attributesSelect": {
          ...defaultSchema[field[this.mappedKeys.type]]["attributesSelect"],
          label: field[this.mappedKeys.placeholder],
          items
        }
      };

      return structuredClone(newProps);
    },
    mountedSchemaForTypeLookupWindow(field) {
      let newProps = _.merge(
        defaultSchema[field[this.mappedKeys.type]],
        this.customSchema["lookupWindows"],
        { 
          "attributesSelect": {
            "label": field[this.mappedKeys.placeholder]
          }
        }
      );

      return structuredClone(newProps);
    },

    generateDynamicSchema() {
      let coreAttributes = this.getCoreAttributes();
      let newSchemas = this.getNewSchemas(coreAttributes);
      this.dynamicSchema = newSchemas;
    },
    getCoreAttributes() {
      let coreAttributes = structuredClone(this.schema);
      if (coreAttributes?.__customAttributes) {
        this.customSchema = structuredClone(coreAttributes.__customAttributes);
        delete coreAttributes.__customAttributes;
      }
      return coreAttributes;
    },
    getNewSchemas(coreAttributes) {
      return this.dynamicModel?.map((field) => this.getNewSchema(field, coreAttributes));
    },
    getNewSchema(field, coreAttributes) {
      const { rules, propsBindSchemaByRules } = this.getRulesAndProps(field);
      const fieldType = field[this.mappedKeys.type];
      const defaultSchemaType = defaultSchema[fieldType];
      const componentAttribute = this.getComponentAttribute(defaultSchemaType.type);
      const idRef = this.mappedKeys[this.idRef]['contextTypeId'];
      const label = field[this.mappedKeys.label];
      const description = field[this.mappedKeys.description] ?? null;
      const model = this.mappedKeys.value;
      const fieldName = `${this.formOptions.mode}-${field[this.mappedKeys.placeholder]}`;
      const styleClasses = "col-12";

      return {
        ...coreAttributes,
        ...defaultSchemaType,
        [componentAttribute]: {
          ...defaultSchemaType[componentAttribute],
          label,
          hint: description
        },
        id: field[idRef],
        fieldGenerateDynamic: field[idRef],
        model,
        label: this.componentShouldShowLabel(fieldType) ? label : "",
        fieldName,
        rules: [...rules ?? [], ...defaultSchemaType?.rules ?? []],
        ...propsBindSchemaByRules,
        styleClasses,
        ...this.mountedSchemaComponentsWithLookup(field)
      }
    },
    getRulesAndProps(field) {
      let rules = [];
      let propsBindSchemaByRules = {};

      if (field?.required) rules = ["required"];
      if (field?.charactersLimit) {
        rules = [...rules, "max"];
        propsBindSchemaByRules = { max: field.charactersLimit }
      }

      return { rules, propsBindSchemaByRules };
    }
  }
};
</script>

<style>
.field-i4proDynamicFields {
  padding: 0 !important;
}
</style>
